import { IconProps } from './types'

export const CheckMarkCircleIcon = ({ size, color }: IconProps) => {
  return (
    <svg
      width={'100%'}
      height={'100%'}
      viewBox="0 0 33 33"
      fill={color || 'currentColor'}
    >
      <rect width={'100%'} height={'100%'} rx="16" />
      <path
        d="M10.2227 16.1612L14.2547 20.1932L23.6627 10.7852"
        stroke="white"
        strokeWidth="2.688"
      />
    </svg>
  )
}
